// extracted by css-extract-rspack-plugin
export default {"labeledToggle":"eGgiZnAbJqIMegXb","label":"cNk6C7PL1lwL12Cv","labelWithTooltip":"hEEmNaMq2lMRtHd6","tooltipIcon":"UYWzEXWbj0OQPhr_"};